<template>
  <div class="glass-overlay-wrapper" :class="{ 'is-active': show }">
    <transition name="fade">
      <div v-if="show" class="glass-overlay" :class="[`blur-${blur}`, variant]">
        <div class="overlay-content">
          <slot name="spinner">
            <GlassSpinner :variant="spinnerVariant" :size="spinnerSize" />
          </slot>
          <span v-if="text" class="overlay-text">{{ text }}</span>
        </div>
      </div>
    </transition>
    <div class="overlay-slot" :class="{ 'rounded': rounded }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import GlassSpinner from './GlassSpinner.vue';

export default {
  name: 'GlassOverlay',
  components: {
    GlassSpinner
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    blur: {
      type: String,
      default: 'md',
      validator: (val) => ['none', 'sm', 'md', 'lg'].includes(val)
    },
    variant: {
      type: String,
      default: 'light'
    },
    spinnerVariant: {
      type: String,
      default: 'primary'
    },
    spinnerSize: {
      type: String,
      default: 'md'
    },
    text: {
      type: String,
      default: ''
    },
    rounded: {
      type: [Boolean, String],
      default: false
    }
  }
};
</script>

<style scoped>
.glass-overlay-wrapper {
  position: relative;
  display: block;
}

.glass-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: inherit;
}

.glass-overlay.light {
  background: rgba(255, 255, 255, 0.7);
}

.glass-overlay.dark {
  background: rgba(0, 0, 0, 0.5);
}

.glass-overlay.transparent {
  background: rgba(255, 255, 255, 0.3);
}

.blur-none {
  backdrop-filter: none;
}

.blur-sm {
  backdrop-filter: blur(2px);
}

.blur-md {
  backdrop-filter: blur(5px);
}

.blur-lg {
  backdrop-filter: blur(10px);
}

.overlay-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.overlay-text {
  font-size: 0.875rem;
  color: var(--color-text-muted);
}

.overlay-slot {
  display: block;
}

.overlay-slot.rounded {
  border-radius: var(--border-radius);
  overflow: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
